import {createFileRoute} from '@tanstack/react-router'

import GoalsScreen from '@protected/goals'

export const Route = createFileRoute('/_protected/goals')({component: GoalsScreen})
